import Header from '../../../components/Header';
import { formSchema } from './formSchema';
import { InputController } from '../../../components/formControllers/input';
import Button from '../../../components/button';
import { useFormWithSchema } from '../../../utils/functions/yupFormTypescript';
import { AutoCompleteController } from '../../../components/formControllers/autoComplete';
import {
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import { useApiHelper } from './apiHelper';

const USER_ACTION_TYPES_TO_REMOVE_POINTS = [
  { value: 'PROMOTIONAL_ACTIVITY', label: 'Promotional' },
  { value: 'OFFER_CASHBACK', label: 'Offer Cashback' },
  { value: 'SPRAY_BOOKING', label: 'Spray Booking' },
  {
    value: 'PRE_CREDIT_SCHEME',
    label: 'Pre-credit Scheme',
  },
];

const USER_ACTION_TYPES_TO_ADD_POINTS = [
  ...USER_ACTION_TYPES_TO_REMOVE_POINTS,
  { value: 'PRODUCT_SCAN', label: 'Scanning' },
];

export const RewardPointsDetails: React.FC = () => {
  const {
    register,
    control,
    formState: { errors },
    handleSubmit,
    watch,
    setValue,
  } = useFormWithSchema(formSchema, {
    mode: 'onTouched',
  });

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const mobileNo = searchParams.get('mobileNo');

  const {
    onSubmitData,
    verifyUidCode,
    resetUidCode,
    isVerifyUidCodeLoading,
    isUpdatePointsLoading,
  } = useApiHelper(mobileNo, setValue);

  return (
    <div className="mt-3">
      <Header
        heading="Add/Remove Reward Points"
        subHeading="fill up the details below to update the reward points"
      />
      <form
        onSubmit={handleSubmit(
          (data) => onSubmitData(data),
          (error) => {
            console.warn(error);
          }
        )}
        className="my-10">
        <div className="my-4 grid grid-cols-2 gap-10">
          Add Points and Remove Points radio input here
        </div>
        <div className="grid grid-cols-2 gap-10">
          <AutoCompleteController
            control={control}
            name="userActionType"
            label="Reason to update points"
            options={
              watch('updateType') === 'pointsRewarded'
                ? USER_ACTION_TYPES_TO_ADD_POINTS
                : USER_ACTION_TYPES_TO_REMOVE_POINTS
            }
            error={errors?.userActionType?.message}
            required
          />
        </div>
        <div className="grid grid-cols-2 gap-10">
          <InputController
            label="Add Comments"
            placeholder="enter comments"
            register={register('adminComments')}
            error={errors?.adminComments?.message}
          />
        </div>
        {watch('userActionType') === 'PRODUCT_SCAN' && (
          <div className="grid grid-cols-2 gap-10 items-center">
            <InputController
              label="UID Code"
              required
              register={register('uidCode')}
              error={
                errors?.uidCode?.message ||
                errors.isUidVerified?.message
              }
            />
            <div>
              {watch('isUidVerified') ? (
                <Button
                  type="button"
                  variant="button--secondary"
                  onClick={resetUidCode}>
                  Reset
                </Button>
              ) : (
                <Button
                  type="button"
                  disabled={
                    !watch('uidCode') ||
                    isVerifyUidCodeLoading
                  }
                  onClick={() =>
                    verifyUidCode(watch('uidCode'))
                  }>
                  Verify
                </Button>
              )}
            </div>
          </div>
        )}
        <div className="grid grid-cols-2 gap-10">
          <InputController
            label="Available Points"
            register={register('availablePoints')}
            error={errors?.availablePoints?.message}
            disabled={!!mobileNo}
          />
        </div>
        <div className="grid grid-cols-2 gap-10">
          <InputController
            label="Points"
            register={register('points')}
            error={errors?.points?.message}
            required
            type="number"
            disabled={
              watch('userActionType') === 'PRODUCT_SCAN'
            }
          />
        </div>

        <div className="col-span-full form-control mt-8 flex justify-end">
          <Button
            type="button"
            className="mr-3"
            variant="button--secondary"
            onClick={() => navigate('/reward-points')}>
            Cancel
          </Button>
          <Button
            type="submit"
            disabled={isUpdatePointsLoading}>
            {mobileNo ? 'Update' : 'Save'}
          </Button>
        </div>
      </form>
    </div>
  );
};
